export const currentYear = new Date().getFullYear();

export const getFormatDate = date => {
  const options = { month: 'short', day: '2-digit', year: 'numeric' };

  return new Date(date).toLocaleDateString('en-US', options);
};

export function formatFrom24To12Hours(timeString) {
  if (!timeString) return null;
  return new Date('1970-01-01T' + timeString + 'Z').toLocaleTimeString(
    'en-US',
    {
      timeZone: 'UTC',
      hour12: true,
      hour: 'numeric',
      minute: 'numeric',
    },
  );
}

export const getNextWeekday = () => {
  const today = new Date();
  const dayOfWeek = today.getDay();

  let daysUntilNextWeekday = 1;
  if (dayOfWeek == 5) {
    daysUntilNextWeekday = 3;
  } else if (dayOfWeek == 6) {
    daysUntilNextWeekday = 2;
  }

  const nextWeekday = new Date(today);
  nextWeekday.setDate(today.getDate() + daysUntilNextWeekday);

  return nextWeekday;
};

export const formatLongDate = date => {
  return new Intl.DateTimeFormat('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  }).format(date);
};

export const formatLongDateTime = datetime => {
  const date = formatLongDate(datetime);
  const time = new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    minute: 'numeric',
  }).format(datetime);
  return `${time}, ${date}`;
};

export const formatInputDate = date => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const formatShortDate = date => {
  return new Intl.DateTimeFormat('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  }).format(date);
};

export const datetimeInputToISO = (date, time) => {
  const combinedDateTime = `${date}T${time}`;
  const dateTime = new Date(combinedDateTime);
  if (isNaN(dateTime.getTime())) return null;

  const iso = dateTime.toISOString();
  return iso;
};

export const newDateWithOffset = dateStr => {
  const date = new Date(dateStr);
  const timezoneOffset = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() + timezoneOffset);
};
